import type { ReactElement } from 'react';
import type { ActivityKind } from 'types';
import { useActivities, activityFieldProps } from 'components/fields/ActivityField';
import { SelectFilterChip } from 'components/filters/SelectFilterChip';

export function ActivityFilterChip({
  name,
  label,
  kind,
}: {
  name: string;
  label?: string;
  kind?: ActivityKind;
}): ReactElement {
  const activities = useActivities();
  const filtered = kind ? activities.filter((a) => a.kind === kind) : activities;
  const options = filtered.map((a) => ({ value: a.id.toString(), label: a.name }));
  return (
    <SelectFilterChip
      name={name}
      label={label}
      options={options}
      isMulti
      formatOptionLabel={(o) => {
        const a = filtered.find((x) => x.id.toString() === o.value);
        return a ? activityFieldProps.formatOptionLabel(a) : o.label;
      }}
    />
  );
}
